<template>
  <Layout>
    <div class="productSolution">
      <div class="productSolution-content">
        <StaticBanner :banner-date="bannerData" />
        <div class="container" data-aos="zoom-in" v-if="imgData">
          <div class="ecop-ai-page_title">
            <div class="font-size-24 fw-bold tab-block_titles text-center lyd-title-colo1 color-black">{{imgData.title}}</div>
            <p class="font-size-14 text-center tab-block_titles">{{imgData.content}}</p>
          </div>
          <div class="ai_product_content">
            <img :src="imgData.img" alt="" />
          </div>
        </div>
        <div class="cardBlock" v-if="cardList" :class="{ bg_practice: currentType === '4' || currentType === '5' || currentType === '7' }">
          <EcopAiBlock :item-list="cardList.itemList" :title="cardList.title" :content="cardList.desc" :type="currentType == '5'?3:4" />
        </div>
        <!-- 产品展示 -->
        <div class="ai_productShow" v-if="productShowData" :class="{'bg_productShow': currentType === '2' || currentType === '6'}">
          <div class="container">
            <div class="ecop-ai-page_title" data-aos="fade-up">
              <div class="font-size-24 fw-bold tab-block_titles text-center lyd-title-colo1 text-balck">{{ productShowData.title }}</div>
              <p class="font-size-14 text-center tab-block_titles">{{ productShowData.content }}</p>
            </div>
            <div class="ai_productShow_content">
              <div class="ai_productShow_item" v-for="(item, index) in productShowData.list" :key="index" 
                :class="{'ai_productShow_item_reverse': item.type === '2', 'ai_productShow_item_5': currentType === '5'}" :data-aos="item.type === '1' ? 'zoom-in-right' : 'zoom-in-left'">
                <img class="ai_productShow_content_img" :src="item.img" alt="">
                <div class="ai_productShow_text">
                  <!-- <img src="@/assets/newImages/productSolution/多模态智能识别@2x.png" alt=""> -->
                  <div class="ai_productShow_text_title">{{ item.title }}</div>
                  <div class="ai_productShow_text_text">{{ item.content }}</div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- ai智慧网银 -->
        <div v-if="currentType === '3'" class="ai_two_card">
          <div class="container">
            <div class="ecop-ai-page_title">
              <div class="font-size-24 fw-bold tab-block_titles text-center lyd-title-colo1 text-balck">{{ two_cardList.title }}</div>
              <p class="font-size-14 text-center tab-block_titles">{{ two_cardList.desc }}</p>
            </div>
            <div class="item-list-2">
              <div class="item-block" v-for="(item, index) in two_cardList.itemList" :key="index" @click="currentHandle(index)" :data-aos="index%2 === 0 ? 'fade-right' : 'fade-left'">
                <div class="item-block-more">
                  了解更多<i class="bi bi-arrow-right" style="font-size: 18px;"></i>
                </div>
                <img :src="item.img" alt="" />
                <div class="item-block-title">{{ item.title }}</div>
                <div class="item-block-text">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="practice-section" v-if="practiceData" :class="{ bg_practice: currentType === '1','bg_practice_5': currentType === '5' }">
          <div class="ecop-ai-page_title container" data-aos="fade-up">
            <div class="font-size-24 fw-bold tab-block_titles text-center lyd-title-colo1 color-black">{{ practiceData.title }}</div>
            <p class="font-size-14 text-center tab-block_titles">{{ practiceData.content }}</p>
          </div>
          <ExpandableCards :items="practiceData.practiceList" />
        </div>
      </div>

      <!-- 模态弹窗 -->
      <div v-if="showImageModal" class="modal-overlay" @click="closeModal">
        <div class="modal-content" data-aos="zoom-in">
          <img :src="imgUl[currentIndex]" alt="" @click="closeModal" />
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/common/Layout.vue";
import ExpandableCards from "@/components/common/ExpandableCards.vue";
import EcopAiBlock from "@/components/common/ecopAiBlock/index.vue";
import StaticBanner from "@/components/common/staticBanner/index.vue";

export default {
  name: "productSolution",
  components: {
    Layout,
    ExpandableCards,
    StaticBanner,
    EcopAiBlock,
  },
  data() {
    return {
      currentType: "1",
      bannerData: {},
      practiceData: [],
      imgData: {},
      productShowData:{},
      cardList: {},
      dataMap: {
        1: {
          bannerData: {
            url: require("@/assets/newImages/productSolution/banner_数据智能体.png"),
            title: '<span style="color:#152131">BossinData</span><span style="color:#1B75ED">数据智能体平台</span>',
            content:
              '<span style="color:#586E8A">融合AI智能体、知识图谱与多Agent协同架构的下一代数据智能平台，能基于行业知识与企业特性，自动完成数据采集、清洗、分析、洞察乃至策略推荐的全过程，并通过多个智能体的高效协作，实现无人值守、实时响应、持续进化的智能决策体验。</span>',
            contentWidth: "600px",
          },
          cardList: {
            title: "核心功能",
            desc: "构建高效数据生态的核心枢纽",
            itemList: [
              {
                img: require("@/assets/newImages/productSolution/数据采集与清洗.png"),
                title: "数据采集与清洗",
                content: "从内外部数据源采集并清洗数据，并确保数据的准确性和完整性",
              },
              {
                img: require("@/assets/newImages/productSolution/数据存储与管理.png"),
                title: "数据存储与管理",
                content: "建立高效的数据存储方式，并进行数据分类标注和权限管理",
              },
              {
                img: require("@/assets/newImages/productSolution/数据处理与分析.png"),
                title: "数据处理与分析",
                content: "进行数据挖掘、建模和可视化，发现数据价值，支持企业决策",
              },
              {
                img: require("@/assets/newImages/productSolution/数据安全与合规.png"),
                title: "数据安全与合规",
                content: "确保数据安全性、完整性和可用性，遵守法律法规和标准，保护数据权益",
              },
              {
                img: require("@/assets/newImages/productSolution/数据治理与资产化.png"),
                title: "数据治理与资产化",
                content: "制定数据标准、数据质量控制、数据访问权限管理等，推动数据资产化",
              },
              {
                img: require("@/assets/newImages/productSolution/数据服务与共享.png"),
                title: "数据服务与共享",
                content: "通过API、数据目录等，数据标准等方式提供数据服务，支持跨部门和跨组织的数据共享",
              },
            ],
          },
          practiceData:{
             title: "平台优势",
             content:
               "构建高效数据生态的核心枢纽",
               practiceList: [
                 {
                   number: "01",
                   title: "多租户管理",
                   content:
                     "采用资源队列技术实现资源隔离，支持基于计算节点和CPU+内存组合的多租户管理模式，并可根据资源池的百分比或固定值灵活分配资源，精准满足不同租户的资源需求。",
                   image1: require("@/assets/newImages/productSolution/卡片_选中状态@2x.png"),
                   image: require("@/assets/newImages/productSolution/卡片_未选中状态@2x.png"),
                 },
                 {
                   number: "02",
                   title: "数据调度",
                   content:
                     "全面涵盖任务编排、资源管理、监控与告警、容错与重试机制、调度策略以及数据一致性与完整性保障，确保数据处理流程高效、稳定且可靠。",
                   image1: require("@/assets/newImages/productSolution/卡片_选中状态@2x.png"),
                   image: require("@/assets/newImages/productSolution/卡片_未选中状态@2x.png"),
                 },
                 {
                   number: "03",
                   title: "数据模型管理",
                   content:
                     "内置经过实战检验的数据规范，支持多种行业建模规范的灵活配置，将传统依赖人工经验与约定的模式转变为系统化的规范方式。同时，兼容常用的关系型数据库和大数据存储，能够满足绝大多数数据质量校验场景的需求。",
                   image1: require("@/assets/newImages/productSolution/卡片_选中状态@2x.png"),
                   image: require("@/assets/newImages/productSolution/卡片_未选中状态@2x.png"),
                 },
                 {
                   number: "04",
                   title: "数据API",
                   content:
                     "通过标准化接口形式，将数据以服务化的方式提供给前端应用。支持多种数据格式，具备实时查询、批量获取和推送功能，同时具备高并发处理能力、数据安全性和权限管理功能，确保数据在传输过程中的安全性和合规性。",
                   image1: require("@/assets/newImages/productSolution/卡片_选中状态@2x.png"),
                   image: require("@/assets/newImages/productSolution/卡片_未选中状态@2x.png"),
                 },
               ],
          },
        },
        2: {
          bannerData: {
            url: require("@/assets/newImages/productSolution/banner_AI审核.png"),
            title: '<span style="color:#152131">智审通 | </span><span style="color:#1B75ED">AI审核</span><span style="color:#152131">平台</span>',
            content:
              '<span style="color:#586E8A">通过AI智能技术实现审核全流程自动化，涵盖从智能填单、AI审核到智能记账的一站式</br>端到端解决方案，助力企业提升审核记账的完整性、准确性、时效性以及风险控制的</br>有效性，实现降本增效，智能风控。</span>',
            contentWidth: "650px",
          },
          cardList: {
            title: "核心功能",
            desc: "降本增效，智能风控",
            itemList: [
              {
                img: require("@/assets/newImages/productSolution/规则自动化配置.png"),
                title: "规则自动化配置",
                content: "对各种审批请求（费用单、合同、发票等）进行第一时间扫描，判定是否符合常规标准或企业合规政策；普通合规单据可直接建议“快速通过”，减少人工检查量。",
              },
              {
                img: require("@/assets/newImages/productSolution/异常检测与风险识别.png"),
                title: "异常检测与风险识别",
                content: "利用机器学习算法，结合历史数据与行为模式识别重复报销、虚假发票、超预算申请等异常；一旦发现可疑线索，自动标注“高风险单据”，推送财务或管理人员二次复核。",
              },
              {
                img: require("@/assets/newImages/productSolution/动态合规策略匹配.png"),
                title: "动态合规策略匹配",
                content: "对“低风险”或“常规”单据给出“通过”建议，对“高风险”自动升级审批，进一步减少人为判断失误；通过学习人工纠正或二次审批的案例，AI持续优化审核策略，越用越精准。",
              },
              {
                img: require("@/assets/newImages/productSolution/跨系统数据核验.png"),
                title: "跨系统数据核验",
                content: "对接业务系统（ERP、CRM、项目管理）和财务系统，自动比对对应信息（预算额度、供应商、合同条款等）多维度检验单据真实性和一致性，及时发现数据不符或缺失",
              },
              {
                img: require("@/assets/newImages/productSolution/审批建议&自学习.png"),
                title: "审批建议&自学习",
                content: "将企业财务制度、业务政策、法规要求封装成可执行的审核策略；如有新规定（差旅标准、报销上限等），可快速更新，AI由新规则驱动，无需手工修改大量逻辑。",
              },
              {
                img: require("@/assets/newImages/productSolution/审计留痕与可视化报表.png"),
                title: "审计留痕与可视化报表",
                content: "将企业财务制度、业务政策、法规要求封装成可执行的审核策略；如有新规定（差旅标准、报销上限等），可快速更新，AI由新规则驱动，无需手工修改大量逻辑。",
              },
            ],
          },
          productShowData:{
            title: "产品展示",
            content: "降本增效，智能风控",
            list:[
              {
                type: "1",
                img: require("@/assets/newImages/productSolution/ai审核_产品截图1@2x.png"),
                title: "多模态智能识别",
                // title: "@/assets/newImages/productSolution/多模态智能识别@2x.png",
                content: "覆盖全场景单据，融合自研计算机视觉(CV)与自然语言处理(NLP)技术，针对全品类单据的结构化数据提取，准确率高达99.9%；",
              },
              {
                type: "2",
                img: require("@/assets/newImages/productSolution/ai审核_产品截图2@2x.png"),
                title: "智能规则引擎与风险预警",
                content: "灵活的规则配置，自动化合规校验贯通合同拟制、评审到履约结算全流程。",
              }
            ]
          },
          practiceData:{
             title: "核心优势",
             content:
               "降本增效，智能风控",
               practiceList: [
                 {
                   number: "01",
                   title: "降本增效",
                   content:
                     "将文档审核时间从平均5-7天锐减至2小时内，实现审核流程的极速优化。大幅削减人力投入，据精准估算，人工审核成本可降低40%-60%，为企业带来显著的成本效益。",
                   image1: require("@/assets/newImages/productSolution/卡片_选中状态@2x.png"),
                   image: require("@/assets/newImages/productSolution/卡片_未选中状态@2x.png"),
                 },
                 {
                   number: "02",
                   title: "财务数据结构化",
                   content:
                     "将财务数据100%结构化，为财务分析模块形成管理量化支撑，为其它智能化产品提供数据基础，提供高质量的数据资产",
                   image1: require("@/assets/newImages/productSolution/卡片_选中状态@2x.png"),
                   image: require("@/assets/newImages/productSolution/卡片_未选中状态@2x.png"),
                 },
                 {
                   number: "03",
                   title: "推动财务标准化<br>体系落地",
                   content:
                     "释放人力低价值工作时间80%，推动与学历知识相匹配的工作内容设计，提升财务作业价值。推动财务标准化体系落地，形成标准化-智能化-更多标准化-更多智能化的良性循环。",
                   image1: require("@/assets/newImages/productSolution/卡片_选中状态@2x.png"),
                   image: require("@/assets/newImages/productSolution/卡片_未选中状态@2x.png"),
                 },
                 {
                   number: "04",
                   title: "提高财务风险<br>管控能力",
                   content:
                     "实现财务初审的工作100%替代，也为共享复审、资金支付的审核要点和共享稽核的工作重点提供风险预警，满足后续数据分析和风险管理需求，提高财务风险管控能力。",
                   image1: require("@/assets/newImages/productSolution/卡片_选中状态@2x.png"),
                   image: require("@/assets/newImages/productSolution/卡片_未选中状态@2x.png"),
                 },
               ],
          },
        },
        3: {
          bannerData: {
            url: require("@/assets/newImages/productSolution/banner_AI智慧网银.png"),
            title: '<span style="color:#152131">AI</span><span style="color:#1B75ED">智慧网银</span>',
            content:
              '<span style="color:#586E8A">智慧网银通过先进的智能化工具，（RPA）和人工智能（AI）</br>为企业提供全面的银行业务自动化处理解决方案。</span>',
            contentWidth: "600px",
          }
        },
        4: {
          bannerData: {
            url: require("@/assets/newImages/productSolution/banner_业财一体化AI.png"),
            title: '<span style="color:#152131">EECloud大企业</span><span style="color:#1B75ED">业财一体化AI</span>',
            content:
              '<span style="color:#586E8A">融合行业属性与智能技术，打造新一代面向集团及超大型企业</br>全场景AI业财一体化应用，实现智能业财协同、对标世界一流，重构企业竞争优势。</span>',
            contentWidth: "600px",
          },
          imgData:{
            title: "EECloud大企业业财一体化AI",
            content:"合规前移，业财融合，数据驱动，重构优势",
            img:require("@/assets/newImages/productSolution/EECloud大企业业财一体化AI.png")
          },
          cardList: {
            title: "产品模块",
            desc: "合规前移，业财融合，数据驱动，重构优势",
            itemList: [
              {
                img: require("@/assets/newImages/productSolution/智能合同管理平台.png"),
                title: "智能合同管理平台",
                content: "智能合同管理平台以项目、合同为源头的全生命周期的智能合同管理，包含合同评审、合同变更、合同结算、合同发票、合同收付款管理。",
              },
              {
                img: require("@/assets/newImages/productSolution/智慧业财管理平台.png"),
                title: "智慧业财管理平台",
                content:
                  "智慧业财管理平台智能报账、发票管理、一键报税、资金结算、电子影像、电子档案、智能技术、移动应用、项目管理和行业属性等全场景。",
              },
              {
                img: require("@/assets/newImages/productSolution/共享运营平台.png"),
                title: "共享运营平台",
                content: "任务提取规则、任务派单规则、单据模板设置、共享服务中心任务处理、作业任务管理、任务查询、绩效考评等模块。",
              },
              {
                img: require("@/assets/newImages/productSolution/行业特性.png"),
                title: "行业特性",
                content: "通过信息化推动企业标准化建设落地，实现管理制度化、制度流程化、流程表单化、表单信息化。",
              },
            ],
          },
          practiceData:{
            title: "整体价值",
            content:
              "合规前移，业财融合，数据驱动，重构优势",
              practiceList: [
                {
                  number: "01",
                  title: "业财融合",
                  content: "多元化、多层级、因地制宜、推行业财融合",
                  image1: require("@/assets/newImages/productSolution/卡片_选中状态@2x.png"),
                  image: require("@/assets/newImages/productSolution/卡片_未选中状态@2x.png"),
                },
                {
                  number: "02",
                  title: "解除困局",
                  content: "破壁垒、通数据，解除业务",
                  image1: require("@/assets/newImages/productSolution/卡片_选中状态@2x.png"),
                  image: require("@/assets/newImages/productSolution/卡片_未选中状态@2x.png"),
                },
                {
                  number: "03",
                  title: "助力经营",
                  content: "控风险、创价值，业财融合",
                  image1: require("@/assets/newImages/productSolution/卡片_选中状态@2x.png"),
                  image: require("@/assets/newImages/productSolution/卡片_未选中状态@2x.png"),
                },
              ],
          }
        },
        5: {
          bannerData: {
            url: require("@/assets/newImages/productSolution/banner_医嘱与病历.png"),
            title: '<span style="color:#152131">医鉴通｜医嘱与病历审核</span><span style="color:#1B75ED">质控智能体</span>',
            content:
              '<span style="color:#586E8A">涵盖规则模型库、知识库、审核引擎、外部接口和智能应用服务，通过集成临</br>床路径、医保政策、药品与耗材目录，能够为医生提供实时的合规提示。</span>',
            contentWidth: "600px",
          },
          imgData:{
            title: "医鉴通 | 医嘱与病历审核质控智能体",
            content:"合规筑基，精益共赢",
            img:require("@/assets/newImages/productSolution/医嘱与病历_img.png")
          },
          cardList: {
            title: "核心功能",
            desc: "合规筑基，精益共赢",
            itemList: [
              {
                img: require("@/assets/newImages/productSolution/医嘱开立前置合规检查.png"),
                title: "医嘱开立前置合规检查",
                content: "可即时拦截各类不合规业务操作如：冲突医嘱、超量程、超说明书、联合用药、权限不符、手术/检查超限、耗材不合规；",
              },
              {
                img: require("@/assets/newImages/productSolution/病历质量与临床路径一致性审核.png"),
                title: "病历质量与临床路径一致性审核",
                content:"诊断-手术-医嘱-检验-耗材全链一致，病案完整、编码规范、围术期节点质控缺陷清单；",
              },
              {
                img: require("@/assets/newImages/productSolution/医保结算前置检查与拒付风险预警.png"),
                title: "医保结算前置检查与拒付风险预警",
                content: "DIP组套、支付限制、超量串项、费用异常，结算前预警并给出整改建议，拒付追偿双降。",
              }
            ],
          },
          productShowData:{
            title: "业务场景",
            content: "合规筑基，精益共赢",
            list:[
              {
                type: "1",
                img: require("@/assets/newImages/productSolution/医嘱与病历_场景一.png"),
                title: "智能医嘱审核",
                // title: "@/assets/newImages/productSolution/多模态智能识别@2x.png",
                content: "针对医嘱开立、签署、保存等关键环节，系统基于标准诊疗路径、医保政策及院内规范自动完成合规性审核，对冲突、重复、超剂量、超疗程、越权用药等情况进行实时识别和判定。",
              },
              {
                type: "2",
                img: require("@/assets/newImages/productSolution/医嘱与病历_场景二.png"),
                title: "病历质控审核",
                content: "对病历全生命周期进行结构化质控，对主诊断、手术、医嘱、检验、影像等信息的完整性、逻辑一致性、时效性和规范性进行自动校验，确保病历质量符合监管和支付要求。",
              },
              {
                type: "1",
                img: require("@/assets/newImages/productSolution/医嘱与病历_场景三.png"),
                title: "医保合规审核与 DIP 结算前置",
                content: "出院前结算，系统对照医保政策、目录限制、支付条件和 DIP 病种费用区间进行逐项审核，提前识别拒付风险，输出风险清单及整改建议，实现“事前控费”。",
              },
              {
                type: "2",
                img: require("@/assets/newImages/productSolution/医嘱与病历_场景四.png"),
                title: "诊疗行为与路径优化辅助",
                content: "在出院前结算环节，系统对照医保政策、目录限制、支付条件和 DIP 病种费用区间进行逐项审核，提前识别拒付风险，输出风险清单及整改建议，实现“事前控费”。",
              },
              {
                type: "1",
                img: require("@/assets/newImages/productSolution/医嘱与病历_场景五.png"),
                title: "高风险病种识别与控费监管",
                content: "过分析历史费用分布、DIP 区间和诊疗路径，系统自动识别费用异常、结构异常和行为异常的病历，为医院开展重点病种监管、专项治理和医保审计对接提供数据支撑。",
              }
            ]
          },
          practiceData:{
            title: "核心价值",
            content:
              "合规筑基，精益共赢",
              practiceList: [
                {
                  number: "01",
                  title: "支付合规与资金安全",
                  content: "把拒付风险关口前移到“开立与录入”，病历规范率可达95%+、医保拒付相关损失下降20-40%、结算周期缩短30-50%；",
                  image1: require("@/assets/newImages/productSolution/卡片_选中状态_2@2x.png"),
                  image: require("@/assets/newImages/productSolution/卡片_未选中状态_2@2x.png"),
                },
                {
                  number: "02",
                  title: "运营质量与收入韧性",
                  content: "在合规前提下实现“控支有度、应收尽收”，并实现绩效联动与科室治理，提升单例经济性与资金回笼效率",
                  image1: require("@/assets/newImages/productSolution/卡片_选中状态_2@2x.png"),
                  image: require("@/assets/newImages/productSolution/卡片_未选中状态_2@2x.png"),
                }
              ],
          }
        },
        6: {
          bannerData: {
            url: require("@/assets/newImages/productSolution/banner_医院AI审核.png"),
            title: '<span style="color:#152131">医院</span><span style="color:#1B75ED">AI审核</span>',
            content:
              '<span style="color:#586E8A">通过AI智能技术实现审核全流程自动化，涵盖从智能填单、AI审核</br>到智能记账的一站式、端到端解决方案。</span>',
            contentWidth: "600px",
          },
          cardList: {
            title: "核心功能",
            desc: "降本增效，智能风控",
            itemList: [
              {
                img: require("@/assets/newImages/productSolution/规则自动化配置.png"),
                title: "规则自动化配置",
                content: "对各种审批请求（费用单、合同、发票等）进行第一时间扫描，判定是否符合常规标准或企业合规政策；普通合规单据可直接建议“快速通过”，减少人工检查量。",
              },
              {
                img: require("@/assets/newImages/productSolution/异常检测与风险识别.png"),
                title: "异常检测与风险识别",
                content:
                  "利用机器学习算法，结合历史数据与行为模式识别重复报销、虚假发票、超预算申请等异常；一旦发现可疑线索，自动标注“高风险单据”，推送财务或管理人员二次复核。",
              },
              {
                img: require("@/assets/newImages/productSolution/动态合规策略匹配.png"),
                title: "动态合规策略匹配",
                content: "对“低风险”或“常规”单据给出“通过”建议，对“高风险”自动升级审批，进一步减少人为判断失误；通过学习人工纠正或二次审批的案例，AI持续优化审核策略，越用越精准。",
              },
              {
                img: require("@/assets/newImages/productSolution/跨系统数据核验.png"),
                title: "跨系统数据核验",
                content: "对接业务系统（ERP、CRM、项目管理）和财务系统，自动比对对应信息（预算额度、供应商、合同条款等）多维度检验单据真实性和一致性，及时发现数据不符或缺失",
              },
              {
                img: require("@/assets/newImages/productSolution/审批建议&自学习.png"),
                title: "审批建议&自学习",
                content: "将企业财务制度、业务政策、法规要求封装成可执行的审核策略；如有新规定（差旅标准、报销上限等），可快速更新，AI由新规则驱动，无需手工修改大量逻辑。",
              },
              {
                img: require("@/assets/newImages/productSolution/审计留痕与可视化报表.png"),
                title: "审计留痕与可视化报表",
                content: "将企业财务制度、业务政策、法规要求封装成可执行的审核策略；如有新规定（差旅标准、报销上限等），可快速更新，AI由新规则驱动，无需手工修改大量逻辑。",
              },
            ],
          },
          productShowData:{
            title: "产品展示",
            content: "降本增效，智能风控",
            list:[
              {
                type: "1",
                img: require("@/assets/newImages/productSolution/医院AI审核_产品截图1@2x.png"),
                title: "多模态智能识别",
                // title: "@/assets/newImages/productSolution/多模态智能识别@2x.png",
                content: "覆盖全场景单据，融合自研计算机视觉(CV)与自然语言处理(NLP)技术，针对全品类单据的结构化数据提取，准确率高达99.9%；",
              },
              {
                type: "2",
                img: require("@/assets/newImages/productSolution/医院AI审核_产品截图2@2x.png"),
                title: "智能规则引擎与风险预警",
                content: "灵活的规则配置，自动化合规校验贯通合同拟制、评审到履约结算全流程。",
              }
            ]
          },
          practiceData:{
            title: "核心优势",
            content:
              "降本增效，智能风控",
              practiceList: [
                {
                  number: "01",
                  title: "降本增效",
                  content: "将文档审核时间从平均5-7天锐减至2小时内，实现审核流程的极速优化。大幅削减人力投入，据精准估算，人工审核成本可降低40%-60%，为企业带来显著的成本效益。",
                  image1: require("@/assets/newImages/productSolution/卡片_选中状态_2@2x.png"),
                  image: require("@/assets/newImages/productSolution/卡片_未选中状态_2@2x.png"),
                },
                {
                  number: "02",
                  title: "财务数据结构化",
                  content: "将财务数据100%结构化，为财务分析模块形成管理量化支撑，为其它智能化产品提供数据基础，提供高质量的数据资产",
                  image1: require("@/assets/newImages/productSolution/卡片_选中状态_2@2x.png"),
                  image: require("@/assets/newImages/productSolution/卡片_未选中状态_2@2x.png"),
                },
                {
                  number: "03",
                  title: "推动财务标准化<br>体系落地",
                  content: "释放人力低价值工作时间80%，推动与学历知识相匹配的工作内容设计，提升财务作业价值。推动财务标准化体系落地，形成标准化-智能化-更多标准化-更多智能化的良性循环。",
                  image1: require("@/assets/newImages/productSolution/卡片_选中状态_2@2x.png"),
                  image: require("@/assets/newImages/productSolution/卡片_未选中状态_2@2x.png"),
                },
                {
                  number: "04",
                  title: "提高财务风险<br>管控能力",
                  content: "实现财务初审的工作100%替代，也为共享复审、资金支付的审核要点和共享稽核的工作重点提供风险预警，满足后续数据分析和风险管理需求，提高财务风险管控能力。",
                  image1: require("@/assets/newImages/productSolution/卡片_选中状态_2@2x.png"),
                  image: require("@/assets/newImages/productSolution/卡片_未选中状态_2@2x.png"),
                },
              ],
          }
        },
        7: {
          bannerData: {
            url: require("@/assets/newImages/productSolution/banner_医院收入运营数据智能体.png"),
            title: '<span style="color:#152131">医院收入运营</span><span style="color:#1B75ED">数据智能体</span>',
            content:
              '<span style="color:#586E8A">通过构建多层级的收入运营分析体系，实现从全院战略总览到科室绩效对比，从病种项目收益到<br>单病历成本的逐级穿透。形成“全院视角—科室对比—病种精算—个案洞察”的一体化分析框架。</span>',
            contentWidth: "680px",
          },
          imgData:{
            title: "医院收入运营数据智能体",
            content:"重新定义医院运营管理智能新边界",
            img:require("@/assets/newImages/productSolution/医院收入运营数据智能体.png")
          },
          cardList: {
            title: "核心价值",
            desc: "重新定义医院运营管理智能新边界",
            itemList: [
              {
                img: require("@/assets/newImages/productSolution/决策跃迁.png"),
                title: "决策跃迁",
                content: "从“基于经验”到“基于实时智能”，高效支撑企业重大决策。",
              },
              {
                img: require("@/assets/newImages/productSolution/全局透视.png"),
                title: "全局透视",
                content: "打破部门壁垒，形成企业级数据全景，洞察经营全貌。",
              },
              {
                img: require("@/assets/newImages/productSolution/自主演进.png"),
                title: "自主演进",
                content: "通过多Agent协同与自学习机制，让数据分析越来越精准。",
              },
              {
                img: require("@/assets/newImages/productSolution/安全可信.png"),
                title: "安全可信",
                content: "企业级数据治理与隐私保护，确保价值释放的同时绝对安全。",
              }
            ],
          },
        },
      },
      currentIndex: 0,
      two_cardList: {
        title: "核心功能",
        desc: "重新定义企业资金管理，构建企业资金管控新引擎",
        itemList: [
          {
            img: require("@/assets/newImages/productSolution/自动化操作全面升级收付款认领.png"),
            title: "自动化操作全面升级收付款认领",
            content: "智能Agent自动采集银行流水、回单及余额，构建企业收付唯一数据源；智能认领自动生成收付款单据，实现交易到入账全流程自动化。",
          },
          {
            img: require("@/assets/newImages/productSolution/实时业务监控与反馈.png"),
            title: "实时业务监控与反馈",
            content: "实现企业全量银行账户余额的实时监控与动态预警，覆盖境内外、本外币、母子账户体系；同步建立全账户流水监控机制，自动抓取、校验、归集各渠道交易明细，确保资金动态可视、风险即时可控，构建企业级资金全景视图。",
          },
          {
            img: require("@/assets/newImages/productSolution/多维度资金数据分析监控.png"),
            title: "多维度资金数据分析监控",
            content: "构建业务到资金的全链路分析体系，实现场景化、动态化、智能化的多维度资金监控。",
          },
          {
            img: require("@/assets/newImages/productSolution/智能Agent签收，高效管理，智能守护，安全无忧.png"),
            title: "智能Agent签收，高效管理，智能守护，安全无忧",
            content: "提供全渠道票据智能签收服务，构建统一票据全生命周期管理平台：实现票据数据集中化台账管理，并实施动态风险监控。",
          },
          {
            img: require("@/assets/newImages/productSolution/通过智能Agent高效采集，智能分类精准检索，数据洞察安全存储，合规保障.png"),
            title: "通过智能Agent高效采集，智能分类精准检索，数据洞察安全存储，合规保障",
            content: "深度学习OCR+NLP模型，破解多银行回单版式差异难题，毫秒级提取金额、账号、日期等关键信息；结构化数据直联财务系统自动入账，实现回单识别→入账全流程自动化，准确率99%+。",
          },
          {
            img: require("@/assets/newImages/productSolution/一键掌控，多银行账户尽在掌中，智能登录，开启金融管理的“自动驾驶”.png"),
            title: "一键掌控，多银行账户尽在掌中，智能登录，开启金融管理的“自动驾驶”",
            content: "支持千枚级U盾集中托管与本地化安全部署，提供多级权限管控（查询/经办/管理）及安全加固机制，满足集团企业海量U盾统一管理需求。",
          },
          {
            img: require("@/assets/newImages/productSolution/智能对账与数据匹配.png"),
            title: "智能对账与数据匹配",
            content: "通过流水与单据的关联，未关联差异数据展示，自动出具银行调节表",
          }
        ],
      },
      imgUl:{
        0: require("@/assets/newImages/productSolution/dialog_img/产品界面图_01@2x.png"),
        1: require("@/assets/newImages/productSolution/dialog_img/产品界面图_02@2x.png"),
        2: require("@/assets/newImages/productSolution/dialog_img/产品界面图_03@2x.png"),
        3: require("@/assets/newImages/productSolution/dialog_img/产品界面图_04@2x.png"),
        4: require("@/assets/newImages/productSolution/dialog_img/产品界面图_05@2x.png"),
        5: require("@/assets/newImages/productSolution/dialog_img/产品界面图_06@2x.png"),
        6: require("@/assets/newImages/productSolution/dialog_img/产品界面图_07@2x.png"),
      },
       showImageModal: false,
    };
  },
  watch: {
    "$route.params.type": {
      handler(val) {
        this.currentType = val || "1";
        this.loadData();
      },
      immediate: true,
    },
  },
  mounted() {
    
  },
  methods: {
    loadData() {
      const data = this.dataMap[this.currentType] || this.dataMap["1"];
      this.bannerData = data.bannerData;
      this.practiceData = data.practiceData;
      this.imgData = data.imgData;
      this.productShowData = data.productShowData;
      this.cardList = data.cardList;
    },
    currentHandle(index){
      this.currentIndex = index;
      this.showImageModal = true;
      // 阻止页面滚动
      document.body.style.overflow = 'hidden';
    },
    closeModal() {
      this.showImageModal = false;
      // 恢复页面滚动
      document.body.style.overflow = '';
    }
  },
};
</script>
